

export const randomNum = (lowestNumber: number, highestNumber: number) => {
    return Math.random() * (highestNumber - lowestNumber) + lowestNumber;

}

export const negativeRandomNum = (lowestNumber: number, highestNumber: number) => {
    return Math.floor(Math.random() * ((highestNumber * 2) - 1)) - lowestNumber;
}